import { gql } from "graphql-request";

export const DELETE_OPERATIONAL_AUDIT = gql`
  mutation DeleteOperationalAudit($id: ID!) {
    deleteOperationalAudit(id: $id)
  }
`;

export const UPDATE_OPERATIONAL_AUDIT = gql`
  mutation UpdateOperationalAudit($input: UpdateOperationalAuditInput!) {
    updateOperationalAudit(input: $input) {
      id
      companyId
      name
      industry
      status
      completedAt
      updatedAt
    }
  }
`;

export const CREATE_OPERATIONAL_AUDIT = gql`
  mutation CreateOperationalAudit($input: CreateOperationalAuditInput!) {
    createOperationalAudit(input: $input) {
      id
      companyId
      tenantId
      name
      industry
      status
      totalQuestionsAnswered
      totalProcessesIdentified
      documentedProcesses
      singlePersonDependencies
      unownedProcesses
      operationalResilienceScore
      createdAt
      updatedAt
      completedAt
    }
  }
`;

export const SUBMIT_OPERATIONAL_AUDIT_RESPONSES = gql`
  mutation SubmitOperationalAuditResponses(
    $input: SubmitOperationalAuditResponsesInput!
  ) {
    submitOperationalAuditResponses(input: $input) {
      id
      status
      completedAt
      totalQuestionsAnswered
      totalProcessesIdentified
      documentedProcesses
      singlePersonDependencies
      unownedProcesses
      operationalResilienceScore
    }
  }
`;